import '../Admin/admin-shared.css'
import '../tools-pages.css'

import { PageHeader, Spinner } from '../../Components'
import { cap } from '../../State'
import { translations } from '../../translations'
import { AdvancedSection } from './Components/AdvancedSection'
import { ChannelParamsSection } from './Components/ChannelParamsSection'
import { ClientConfigBar } from './Components/ClientConfigBar'
import { EnvironmentSection } from './Components/EnvironmentSection'
import { ExecutionSection } from './Components/ExecutionSection'
import { PresetBar } from './Components/PresetBar'
import { ResponseInspector } from './Components/ResponseInspector'
import { useDebugChat } from './hooks/useDebugChat'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Console di debug completa per testare tutti i flussi di Nora.
 * Espone tutti i parametri dell'API /public con preset salvabili,
 * inspector JSON e supporto a tutti i canali di comunicazione.
 */
export function NewChat() {
  const {
    config,
    setField,
    setNested,
    units,
    travellersOptions,
    filteredEnvironments,
    messages,
    lastResponse,
    isLoading,
    responseStatus,
    conversationId,
    isReady,
    configIssues,
    sendMessage,
    buildPayload,
    resetConversation,
    loadPresets,
    savePreset,
    deletePreset,
    loadPreset,
    resetToDefaults,
    loadClientConfig
  } = useDebugChat()

  if (!isReady) {
    return (
      <div className="chat-page">
        <Spinner />
      </div>
    )
  }

  return (
    <div className="chat-page admin-page--editor">
      <PageHeader
        title={t.dbcTitle || 'Debug Console'}
        subtitle={
          t.dbcSubtitle || 'Console completa per testare tutti i flussi, canali e parametri di Nora'
        }
      />

      <div className="debug-toolbar">
        <PresetBar
          loadPresets={loadPresets}
          savePreset={savePreset}
          deletePreset={deletePreset}
          loadPreset={loadPreset}
          resetToDefaults={resetToDefaults}
          resetConversation={resetConversation}
        />

        <ClientConfigBar
          onLoadClientConfig={loadClientConfig}
          resetConversation={resetConversation}
        />
      </div>

      <div className="debug-console-grid">
        <div className="debug-console-grid__config">
          <EnvironmentSection
            config={config}
            setField={setField}
            filteredEnvironments={filteredEnvironments}
            travellersOptions={travellersOptions}
          />

          <ExecutionSection config={config} setField={setField} units={units} />

          <ChannelParamsSection config={config} setField={setField} setNested={setNested} />

          <AdvancedSection config={config} setField={setField} buildPayload={buildPayload} />
        </div>

        <div className="debug-console-grid__chat">
          <ResponseInspector
            messages={messages}
            lastResponse={lastResponse}
            isLoading={isLoading}
            responseStatus={responseStatus}
            sendMessage={sendMessage}
            conversationId={conversationId}
            config={config}
            configIssues={configIssues}
          />
        </div>
      </div>
    </div>
  )
}
